module.exports = __webpack_public_path__ + "img/suijin-chart-car-tate.68e404a6.png";